import React, { useState } from 'react'
import Swal from 'sweetalert2'

// CommonJS
import Button from '@mui/material/Button'
import './Home.css'
// import User from './Cliente'
import { Link, Navigate, redirect, useLocation } from 'react-router-dom'
import { TextField } from '@mui/material'
import Carrusel from '../Carrusel'
import video from '../../fondo/video.mp4'
import { useDispatch } from 'react-redux'
import { getUserByEmail, login, register } from '../../actions'
//IMPORTAR CARRUSEL

function Home() {
  const [datos, setDatos] = useState({})
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [modal, setModal] = useState(false)
  const dispatch = useDispatch()
  const location = useLocation()
  const Swal = require('sweetalert2')

  const validationEmail = () => {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top',
      timer: 3000,
      showConfirmButton: false,
      // width: '15%',
      padding: '0.3rem',
      //timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    })
    Toast.fire({
      icon: 'error',
      html: '<b class="rojo">Invalid email</b>'
    })
  }
  const validationPassword = () => {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top',
      showConfirmButton: false,
      timer: 3000,
      // width: '24%',
      padding: '0.3rem',
      //timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    })
    Toast.fire({
      icon: 'error',
      html: '<b class="rojo">Invalid password</b>'
    })
  }

  const handleChange = (e) => {
    setDatos({ ...datos, [e.target.name]: e.target.value.toLowerCase() });
  }
  // console.log(datos.email.toLowerCase(),'clg')
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const user = await dispatch(getUserByEmail(datos.email))
      // console.log(user.data.password,'contra')
      // console.log(datos.password,'contra2')
      // if (datos.password.length < 6) return validationPassword()
      if (datos.email < 5) return validationEmail()

      if (!user.data) {
        return validationEmail()
      }
      else if (user.data.password === datos.password) {
        // Si ambas coinciden, permitir el acceso al usuario
        console.log("Acceso concedido");
        dispatch(login(datos))

        const Toast = Swal.mixin({
          toast: true,
          position: 'top',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        })

        Toast.fire({
          icon: 'success',
          title: 'Login successfully'
        }).then((result) => {
          console.log(result)
          if (!result.isConfirmed) {

            window.location.href = `/client/${datos.email}`
          }
        }
        )


      } else {
        // Si la contraseña no coincide, mostrar un mensaje de error indicando que las credenciales son incorrectas
        console.log("Credenciales incorrectas");

        return validationPassword()
      }
    } catch (error) {
      console.log(error)
    }
    // console.log(datos,'login')
    // setDatos()
  }


  return (

    <div className='main'>
      <div className="overlay"></div>
      <video src={video} autoPlay loop muted />
      <div className="content">
        <h1>Quienes Somos?</h1>
        
        <p>Somos un grupo de trabajo conformado por el Estudio Contable Seffino y el Estudio de Arquitectos Lucrecia Calvo & asoc., nos caracterizamos por mantener una permanente relación propietario – administrador, enfocada en el trato personalizado, el respeto y la confianza.
          Nuestras experiencias desde la actividad contable y de arquitectura nos permite lograr una fusión particular para llevar a cabo esta actividad mediante una visión diferente.</p>


        <div >
          <form onSubmit={handleLogin}>
            <div className='botones'>


              <TextField id="standart-basic" label="Usuario" variant="filled" type="text" name="email" onChange={handleChange} />


              <TextField id="standart-basic" label="Constraseña" variant="filled" type="password" name="password" onChange={handleChange} />



              <Button variant='contained' type='submit' id='btn'>
                Iniciar Sesion
              </Button>


            </div>
          </form>
        </div>


      </div>
    </div>
  )
}

export default Home